import { Textarea } from "@mantine/core";
import { useInputStyles } from "./FieldTextValue";
import textareaClasses from "./FieldTextareaValue.module.css";

type Props =
  | {
      formProps: any;
      label: string;
      editing: boolean;
      value?: undefined;
      minRows?: number;
      maxRows?: number;
    }
  | {
      formProps?: undefined;
      label: string;
      editing?: undefined;
      value: string | null | undefined;
      minRows?: number;
      maxRows?: number;
    };

export default function FieldTextareaValue({
  editing,
  formProps,
  value,
  label,
  minRows = 5,
  maxRows = 25,
}: Props) {
  const { classes: inputClasses } = useInputStyles();
  return (
    <Textarea
      label={label}
      disabled={!editing}
      size="md"
      variant="default"
      autosize
      minRows={minRows}
      maxRows={maxRows}
      {...formProps}
      classNames={{
        input: textareaClasses.textarea,
        label: inputClasses.label,
      }}
      value={value != null ? value : formProps?.value}
    />
  );
}
